﻿import * as React from "react";

export const ErrorPage: React.FunctionComponent = (): React.ReactElement => (
    <div className={`support-error`}>
        <div className={`support-error-imagecontainer`}>
            <img
                className={`support-error-image`}
                src={`/Images/ErrorImage.png`}
            />
        </div>
        <h2>OOPS WE HAVE A PROBLEM</h2>
        <p>
            Something went wrong. Please try again or alternatively, you can
            send your request to
            <a href={`mailto:support@metricell.co.uk`}>
                support@metricell.co.uk
            </a>
            .
        </p>
    </div>
);
